// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__gGAnF","alert":"SettungsInbox_alert__2loKC"};